import { createSelector } from 'reselect'
import { StateInterface } from '../types/states'

const selectDialogsDomain = (state: StateInterface) => state.dialogs
const selectDialogVisibility = createSelector(selectDialogsDomain, dialogs => dialogs.visibility)
const selectDialogSize = createSelector(selectDialogsDomain, dialogs => dialogs.size)

export { selectDialogsDomain, selectDialogVisibility, selectDialogSize }
